let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7sIWI")).then(() => parcelRequire('5WUAn'));